module.exports = __webpack_public_path__ + "img/restaurant.be5030ca.webp";